// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2aMeo","bigColWidth":"Table_bigColWidth__1Af-Y","biggerColWidth":"Table_biggerColWidth__1SYrV","row":"Table_row__2JK94","col":"Table_col__1qbRr"};